const myOrdersState = [];

module.exports = function myOrdersReducer(state = myOrdersState, action) {
	switch (action.type) {
		case "LOAD_MYORDERS":
			return action.payload;

		case "CREATE_MYORDER":
			return state.push(action.payload);

		case "UPDATE_MYORDER":
			return state.map((order) => { 
				return order.key === action.payload.key ? action.payload : order 
			});

		case "DELETE_MYORDER":
			return state.filter((order) => { 
				return order.key !== action.payload.key 
			});

		case "UNLOAD_MYORDERS":
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/myorders.js